import React, { useContext } from 'react';
import { AuthContext } from '@/App';

/**
 * Componente para proteger features premium
 * 
 * Uso:
 * <PremiumGate fallback={<UpgradePrompt />}>
 *   <ComponentePremium />
 * </PremiumGate>
 */
const PremiumGate = ({ children, fallback = null }) => {
  const { user } = useContext(AuthContext);

  // Check if user is premium or pro (including trialing status)
  const isPremium = (user?.subscription_tier === 'premium' || user?.subscription_tier === 'pro') && (user?.subscription_status === 'active' || user?.subscription_status === 'trialing');

  if (!isPremium) {
    return fallback;
  }

  return <>{children}</>;
};

export default PremiumGate;
